import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import * as React from "react";

export default function WrittenTestimonialsSection() {
  const testimonials = [
    {
      name: "ندى",
      country: "ليبيا",
      flag: "🇱🇾",
      text: "التجربة حلوة جداً، كنت داخلة معاكم قبل بس ماكملت... لكن المرة هذي الحمدلله دخلت وكنت أول بأول أحضر وأطبق. برنامجكم وتعليمكم ممتاز جداً وبدأت أكسب من 99$ لـ 180$ ثم رجعت التزمت وصار تقريباً 150$ والحمدلله.",
      rating: 5,
    },
    {
      name: "أحمد",
      country: "فلسطين",
      flag: "🇵🇸",
      text: "يعطيكون العافية صراحة أحلى مجتمع وأفضل تعليم من خلال تجربتي عدة مرات. تبسيط المعلومة وإعطاء الزبدة بعيداً عن مضيعة الوقت كان شي كتير إيجابي. شكراً الكون على كل شي والحماس مليون.",
      rating: 5,
    },
    {
      name: "زيد",
      country: "الأردن",
      flag: "🇯🇴",
      text: "الحمدلله أنا بلشت من أسبوع ولكن في تقدم ملحوظ رغم أني ما لحقت الصفقات كلها لكن طلعت بربح 30%. بشكر الفريق كاملاً على كل المعلومات والصفقات وعلى كل التعب والمحتوى يلي عم يقدموه.",
      rating: 5,
    },
    {
      name: "رزان",
      country: "السعودية",
      flag: "🇸🇦",
      text: "استمتعت كتير بالتجربة وصراحة هذي المرة التزمت أكتر بالموضوع وبالتعليم وجبت نتيجة حلوة حمدلله. تعلمت شوي كيف أحلل وأكتر إنجاز شفته أني ضاعفت رأس مالي من أسبوع كان شي خلاني أتحمس أكتر للمجال.",
      rating: 5,
    },
    {
      name: "ريم",
      country: "الإمارات",
      flag: "🇦🇪",
      text: "التجربة رائعة جداً وممنونة أنه صحتلي هالفرصة. كنت صفر معرفة بالمجال لما سجلت معكم، لكن معكم خلال أسبوعين صرت فاهمة شو يعني تداول وعرفت أعمل مبلغ بالأسبوع الحالي بفضلكم.",
      rating: 5,
    },
    {
      name: "مروة",
      country: "مصر",
      flag: "🇪🇬",
      text: "تجربتي كانت مميزة بمجتمع elev8 club 🔥 مجتمع ناري صراحة وتجربة عظيمة. الكوتش محمد ماشاءالله بشرح بطريقة عظيمة وسلسة. الحمدلله من رأس مال 100$ لـ 524$ خلال شهر. المزيد من الدولارات قادمة 💸🤑",
      rating: 5,
    },
  ];

  const [currentIndex, setCurrentIndex] = React.useState(0);

  const decorativeDots = React.useMemo(() => {
    /* eslint-disable react-hooks/purity */
    return Array.from({ length: 30 }, () => ({
      left: Math.random() * 100,
      top: Math.random() * 100,
    }));
    /* eslint-enable react-hooks/purity */
  }, []);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      visible.push(testimonials[(currentIndex + i) % testimonials.length]);
    }
    return visible;
  };

  return (
    <section className="relative py-24 bg-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        {decorativeDots.map((dot, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-[#CFAE58] rounded-full"
            style={{
              left: `${dot.left}%`,
              top: `${dot.top}%`,
            }}
          ></div>
        ))}
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1E3F] mb-4">
            💬 تجارب <span className="text-[#CFAE58]">حقيقية</span> من مجتمعنا
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            اقرأ قصص نجاح حقيقية من أعضاء بدأوا التحدي وحققوا نتائج ملموسة
          </p>
        </motion.div>

        {/* Testimonials Slider */}
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {getVisibleTestimonials().map((testimonial, index) => (
              <motion.div
                key={`${testimonial.name}-${index}`}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative"
              >
                <div className="bg-gradient-to-br from-[#0A1E3F]/5 to-white border-2 border-[#CFAE58]/30 rounded-2xl p-8 hover:border-[#CFAE58] transition-all duration-300 hover:shadow-2xl hover:shadow-[#CFAE58]/20 transform hover:scale-105 h-full flex flex-col">
                  {/* Quote Icon */}
                  <div className="absolute top-4 right-4 opacity-20">
                    <Quote className="w-12 h-12 text-[#CFAE58]" fill="#CFAE58" />
                  </div>

                  {/* Rating */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 text-[#CFAE58] fill-[#CFAE58]" />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-[#0A1E3F] text-base mb-6 leading-relaxed italic flex-grow">
                    "{testimonial.text}"
                  </p>

                  {/* User Info */}
                  <div className="flex items-center gap-3 pt-4 border-t border-[#CFAE58]/20">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#CFAE58] to-[#B89A45] rounded-full flex items-center justify-center text-2xl flex-shrink-0">
                      {testimonial.flag}
                    </div>
                    <div>
                      <h4 className="text-[#0A1E3F] font-bold">{testimonial.name}</h4>
                      <p className="text-[#CFAE58] text-sm">{testimonial.country}</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? "bg-[#CFAE58] w-8"
                    : "bg-[#CFAE58]/30 hover:bg-[#CFAE58]/50"
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
